import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'animate.css'
import '@mzara/component/dist/main.css'
import '@mzara/component/dist/index.css'
import '@mzara/login/dist/main.css'
import '@mzara/translation/dist/main.css'
import '@mzara/wizard/dist/main.css'
import '@mzara/wizard-node/dist/main.css'
import '@mzara/user-management/dist/main.css'
import '@mzara/document-template/dist/main.css'
import '@mzara/static-page/dist/main.css'
import './index.css';

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
